export default "__VITE_ASSET__B$j2T2LC__"